<template>
    <v-list :class="`overflow-scroll h-[calc(100%-70px)]  !bg-black !relative`" dark>
        <LoadingSpinner v-if="transactionLoading" class="h-full w-full " />
        <div :class="`h-[10vh] bg-black flex items-center justify-center text-xl ${routeLink}-border font-Nunito border-[1px] rounded-md`  " v-if="!transactions" v-motion :initial="{
            y: 100,
            opacity: 0,
        }" :enter="{
    y: 0,
    opacity: 1,
    transition: {
        duration: 300,
        type: 'keyframes',
        ease: 'easeInOut',
        delay: `100`
    },
}">
            No Trasaction History
        </div>
        <v-list-item v-for="(item, idx) in transactions" :key="item.id" v-else
            :class="`!border-[1px] py-2 ${routeLink}-border font-Nunito text-sm rounded-md my-2`" v-motion :initial="{
                y: 100,
                opacity: 0,
            }" :enter="{
    y: 0,
    opacity: 1,
    transition: {
        duration: 300,
        type: 'keyframes',
        ease: 'easeInOut',
        delay: `${idx}00`
    },
}">
            <div class="!flex items-center justify-between w-full gap-2">
                <div class="bg-gray-700 rounded-lg">
                    <div :class="`flex flex-col bg-white !grow-0  rounded-lg p-2 text-center ${routeLink}_fortext`">
                        <div class="">{{ item.month }}</div>
                        <div class="">{{ item.year }}</div>
                    </div>
                </div>
                <div class="text-sm  whitespace-nowrap overflow-hidden text-ellipsis">
                    {{ item.invoice_number }}
                </div>
                <div class="text-sm whitespace-nowrap">
                    $ {{ item.amount }}
                </div>
                <div class="!grow-0">
                    <v-btn @click.prevent="showReceiptHandler(item)" icon small>
                        <v-icon :color="colorAsRoute" :class="`!text-3xl`">
                            mdi-arrow-right-circle-outline
                        </v-icon>
                    </v-btn>
                </div>
            </div>
        </v-list-item>
        <TransactionReceipt :showReceipt="showReceipt" :receiptData="currentActiveReceipt"
            @closeReceipt="showReceipt = false" />
    </v-list>
</template>
<script>
import axios from 'axios';
import TransactionReceipt from './TransactionReceipt.vue';
import LoadingSpinner from '@/pages/front/straight/childs/LoadingSpinner.vue';

export default {
    data() {
        return {
            transactions: [],
            transactionLoading : false,
            showReceipt: false,
            currentActiveReceipt: {},
        };
    },
    methods: {
        showReceiptHandler(receipt) {
            this.showReceipt = true;
            this.currentActiveReceipt = receipt
        },
        async getTransactionHistory() {

            try {
                this.transactionLoading = true;
                const { data } = await axios.get('user/invoices')
                this.transactions = data.invoices
                console.log(data)
            } catch (error) {
                console.log(error.response);
            } finally {
                this.transactionLoading = false;
            }
        },
    },
    computed: {
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },
    },
    components: { TransactionReceipt, LoadingSpinner },
    created() {
        this.getTransactionHistory()
    },
}
</script>

<style scoped>
.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}
</style>